import React from "react";
import { useLocale } from "@insightfulscience/smart-react/i18";
import WistiaVideo from "@insightfulscience/atomic-react/WistiaVideo";
import WistiaVideoBlockDetail, {
	WistiaVideoBlockDetailFrame,
	WistiaVideoBlockDetailInfo,
	WistiaVideoBlockDetailInfoItem,
} from "@insightfulscience/atomic-react/WistiaVideo/BlockDetail";
import WistiaVideoEmbed from "@insightfulscience/atomic-react/WistiaVideoEmbed";
import { arrayOf, elementType, shape, string } from "prop-types";
import videoDto from "../../dtos/video.dto";

const itemPropTypes = {
	id: string,
	title: string,
	description: string,
	videoUrl: string,
	lengthString: string,
};

const Item = ({ id, title, description = "", videoUrl, lengthString = "" }) => {
	const [t] = useLocale("series");
	return (
		<WistiaVideoBlockDetail id={id} dataId={id}>
			<WistiaVideoBlockDetailFrame dataId={id}>
				<WistiaVideoEmbed url={videoUrl} />
			</WistiaVideoBlockDetailFrame>
			<WistiaVideoBlockDetailInfo title={title}>
				{description ? (
					<WistiaVideoBlockDetailInfoItem title={t("VIDEO_SUBTITLE_TEXT")}>
						{description}
					</WistiaVideoBlockDetailInfoItem>
				) : null}
				{lengthString ? (
					<WistiaVideoBlockDetailInfoItem title={t("VIDEO_SUBTITLE_LENGTH")}>
						{lengthString}
					</WistiaVideoBlockDetailInfoItem>
				) : null}
			</WistiaVideoBlockDetailInfo>
		</WistiaVideoBlockDetail>
	);
};

Item.propTypes = itemPropTypes;

const WistiaVideos = ({ TagItems = WistiaVideo, ItemTag = Item, items }) => {
	return (
		<TagItems list={items}>
			{items.map(item => {
				const itemProps = videoDto(item);
				const { id } = itemProps;
				return <ItemTag key={id} {...itemProps} />;
			})}
		</TagItems>
	);
};

WistiaVideos.propTypes = {
	TagItems: elementType,
	ItemTag: elementType,
	items: arrayOf(shape(itemPropTypes)),
};

export default WistiaVideos;
